module.exports = __webpack_public_path__ + "static/media/shape1_7.ff422a26.obj";